import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interventions',
  templateUrl: './interventions.component.html',
  styleUrls: ['./interventions.component.scss']
})
export class InterventionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
